export const chipsBurned = {
	byEmployee: {
		label: "Chips burned by employee",
		sheetFileName: "chips-burned-employee",
	},
	label: "Total chips burned",
	sheetFileName: "total-chips-burned",
	since: "Since",
	until: "Until",
	loading: "Generating spreadsheet",
	columns: {
		name: "Name",
		count: "Amount",
		unitaryCount: "Unit quantity",
		fracionalCount: {
			label: "Fracional amount",
			grams: "grams",
			kg: "Kilos",
			lt: "Liters",
		},
		unitaryValue: "Unitary value",
		subtotal: "Subtotal",
		discount: "Discounts",
		totalValue: "Total",
		type: "Type",
	},
	total: "TOTAL",
	totalItem: "Total",
	mountableModal: {
		name: "Name",
		section: "Mountable session",
		count: "Amount",
	},
	mountables: {
		label: "Mountables",
		fiscalCode: "SKU",
		product: "Product",
		category: "Category",
		section: "Mountable step",
		name: "Mountable item",
		count: "Amount",
	},
};
